module.exports = __webpack_public_path__ + "static/media/PM100.c0428d55.png";